// src/styles/styles.js

export const styles = {
    container: {
        fontFamily: "'Montserrat', sans-serif",
        color: "#4A4A4A",
        maxWidth: "100%",
        margin: "0 auto",
        padding: 0,
        boxSizing: "border-box",
        overflowX: "hidden",
        backgroundColor: "#fff",
    },

    // Header Styles
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "15px 20px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 15px rgba(0,0,0,0.05)",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        borderBottom: "3px solid #EFEBE9",
    },
    logoContainer: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
    },
    logoText: {
        marginLeft: "10px",
    },
    mobileMenuButton: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "30px",
        height: "22px",
        cursor: "pointer",
        zIndex: 1100,
        "@media (min-width: 768px)": {
            display: "none",
        },
    },
    menuBar: {
        height: "3px",
        width: "100%",
        borderRadius: "5px",
        transition: "all 0.3s ease",
    },
    nav: {
        position: "fixed",
        top: "70px",
        left: 0,
        right: 0,
        backgroundColor: "#fff",
        borderBottom: "3px solid #EFEBE9",
        boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
        "@media (min-width: 768px)": {
            position: "static",
            boxShadow: "none",
            borderBottom: "none",
            display: "flex !important",
        },
    },
    navList: {
        display: "flex",
        flexDirection: "column",
        listStyle: "none",
        margin: 0,
        padding: "10px 0",
        "@media (min-width: 768px)": {
            flexDirection: "row",
            padding: 0,
        },
    },
    navItem: {
        margin: "10px 20px",
        padding: "5px 0",
        cursor: "pointer",
        transition: "all 0.3s",
        fontWeight: "bold",
        position: "relative",
        textAlign: "center",
        "@media (min-width: 768px)": {
            margin: "0 15px",
        },
    },

    // Hero & Slider Styles
    hero: {
        height: "80vh",
        position: "relative",
        overflow: "hidden",
    },
    slider: {
        width: "100%",
        height: "100%",
        position: "relative",
    },
    slide: {
        width: "100%",
        height: "100%",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "absolute",
        top: 0,
        left: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    slideContent: {
        zIndex: 1,
        padding: "20px 30px",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderRadius: "20px",
        maxWidth: "800px",
        margin: "0 20px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    },
    slideTitle: {
        fontSize: "2.5rem",
        marginBottom: "15px",
        color: "#8D6E63",
        fontFamily: "'Playfair Display', serif",
        "@media (max-width: 768px)": {
            fontSize: "1.8rem",
        },
    },
    slideDescription: {
        fontSize: "1.2rem",
        marginBottom: "20px",
        "@media (max-width: 768px)": {
            fontSize: "1rem",
        },
    },
    sliderDots: {
        position: "absolute",
        bottom: "30px",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        zIndex: 5,
    },
    sliderDot: {
        width: "12px",
        height: "12px",
        borderRadius: "50%",
        margin: "0 8px",
        border: "none",
        cursor: "pointer",
        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    },
    scrollIndicator: {
        position: "absolute",
        bottom: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        cursor: "pointer",
        zIndex: 10,
    },

    // Section Styles
    section: {
        padding: "80px 20px",
        "@media (max-width: 768px)": {
            padding: "60px 20px",
        },
    },
    sectionTitle: {
        textAlign: "center",
        marginBottom: "40px",
        fontSize: "2.2rem",
        fontWeight: "bold",
        position: "relative",
        paddingBottom: "15px",
        fontFamily: "'Playfair Display', serif",
        "@media (max-width: 768px)": {
            fontSize: "1.8rem",
        },
        "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "80px",
            height: "4px",
            backgroundColor: "#D7CCC8",
            borderRadius: "2px",
        },
    },
    subsectionTitle: {
        textAlign: "center",
        marginTop: "50px",
        marginBottom: "30px",
        fontSize: "1.8rem",
        fontWeight: "bold",
        position: "relative",
        paddingBottom: "10px",
        fontFamily: "'Playfair Display', serif",
    },

    // About Section
    aboutContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "1200px",
        margin: "0 auto",
        "@media (min-width: 768px)": {
            flexDirection: "row",
            alignItems: "flex-start",
        },
    },
    aboutText: {
        flex: 1,
        marginBottom: "30px",
        lineHeight: "1.8",
        "@media (min-width: 768px)": {
            marginRight: "50px",
            marginBottom: 0,
        },
    },
    aboutImage: {
        flex: 1,
    },
    image: {
        width: "100%",
        borderRadius: "20px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    },

    // Elterntiere Section
    elternIntro: {
        maxWidth: "800px",
        margin: "0 auto 40px",
        textAlign: "center",
    },
    elternText: {
        fontSize: "1.1rem",
        lineHeight: "1.8",
    },
    elternGrid: {
        display: "flex",
        flexDirection: "column",
        gap: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
        "@media (min-width: 768px)": {
            flexDirection: "row",
        },
    },
    elternCard: {
        flex: 1,
        backgroundColor: "#fff",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
        transition: "all 0.3s ease",
    },
    elternImageContainer: {
        position: "relative",
        height: "300px",
        overflow: "hidden",
    },
    elternImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    elternRoleBadge: {
        position: "absolute",
        bottom: "15px",
        right: "15px",
        color: "#fff",
        padding: "8px 15px",
        borderRadius: "30px",
        fontWeight: "bold",
        fontSize: "14px",
        boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
    },
    elternColorBadge: {
        position: "absolute",
        top: "15px",
        right: "15px",
        backgroundColor: "#BCAAA4",
        color: "#fff",
        padding: "5px 10px",
        borderRadius: "20px",
        fontSize: "12px",
        fontWeight: "bold",
        boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
    },
    elternInfo: {
        padding: "25px",
    },
    elternBreed: {
        margin: "5px 0 15px",
        color: "#888",
    },
    elternDescription: {
        marginBottom: "20px",
        lineHeight: "1.8",
    },
    elternDetails: {
        borderTop: "1px solid #eee",
        paddingTop: "20px",
    },
    elternDetail: {
        marginBottom: "15px",
    },
    elternList: {
        margin: "5px 0 0 20px",
        padding: 0,
    },

    // Junge Hunde
    jungeHundeGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: "30px",
        maxWidth: "1200px",
        margin: "0 auto",
        "@media (min-width: 768px)": {
            gridTemplateColumns: "repeat(2, 1fr)",
        },
    },
    jungeHundeCard: {
        backgroundColor: "#fff",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
        transition: "all 0.3s ease",
    },
    jungeHundeImageContainer: {
        position: "relative",
        height: "250px",
        overflow: "hidden",
    },
    jungeHundeImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    jungeHundeColorBadge: {
        position: "absolute",
        top: "15px",
        right: "15px",
        backgroundColor: "#BCAAA4",
        color: "#fff",
        padding: "5px 10px",
        borderRadius: "20px",
        fontSize: "12px",
        fontWeight: "bold",
        boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
    },
    jungeHundeInfo: {
        padding: "20px",
    },
    jungeHundeBreed: {
        margin: "5px 0 10px",
        color: "#888",
    },
    jungeHundeDescription: {
        lineHeight: "1.8",
    },

    // Seminare und Fortbildungen
    seminareContainer: {
        maxWidth: "900px",
        margin: "50px auto 0",
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "20px",
        boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
    },
    seminareIntro: {
        textAlign: "center",
        marginBottom: "25px",
    },
    seminareGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: "15px",
        marginBottom: "30px",
        "@media (min-width: 768px)": {
            gridTemplateColumns: "repeat(2, 1fr)",
        },
    },
    seminarBadge: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#F5F0EB",
        padding: "12px 15px",
        borderRadius: "15px",
        transition: "all 0.3s ease",
        "& svg": {
            marginRight: "10px",
            flexShrink: 0,
        },
    },
    zertifikatRow: {
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        marginTop: "30px",
        "@media (min-width: 768px)": {
            flexDirection: "row",
        },
    },
    zertifikatBadge: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#F5F0EB",
        padding: "15px",
        borderRadius: "15px",
        transition: "all 0.3s ease",
        flex: 1,
    },
    zertifikatIcon: {
        backgroundColor: "#fff",
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "15px",
        flexShrink: 0,
        boxShadow: "0 5px 10px rgba(0,0,0,0.05)",
    },
    zertifikatInfo: {
        flex: 1,
    },
    zertifikatTitle: {
        fontWeight: "bold",
        margin: "0 0 5px",
        fontSize: "0.9rem",
    },
    zertifikatDate: {
        color: "#A1887F",
        fontSize: "0.8rem",
        margin: 0,
    },

    // Welpen Section
    wurfHeader: {
        textAlign: "center",
        marginBottom: "30px",
    },
    wurfTitle: {
        fontSize: "1.8rem",
        margin: "0 0 10px",
    },
    wurfInfo: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "15px",
    },
    wurfDate: {
        backgroundColor: "#EFEBE9",
        padding: "5px 15px",
        borderRadius: "30px",
        fontSize: "14px",
        color: "#8D6E63",
        fontWeight: "bold",
    },
    wurfCount: {
        backgroundColor: "#D7CCC8",
        padding: "5px 15px",
        borderRadius: "30px",
        fontSize: "14px",
        color: "#5D4037",
        fontWeight: "bold",
    },
    wurfParents: {
        backgroundColor: "#BCAAA4",
        padding: "5px 15px",
        borderRadius: "30px",
        fontSize: "14px",
        color: "#fff",
        fontWeight: "bold",
    },
    wurfGruppenbildContainer: {
        maxWidth: "900px",
        margin: "0 auto 50px",
        textAlign: "center",
    },
    wurfGruppenbild: {
        width: "100%",
        borderRadius: "20px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        marginBottom: "20px",
    },
    wurfDescription: {
        maxWidth: "700px",
        margin: "0 auto",
        lineHeight: "1.8",
        fontSize: "1.1rem",
        fontStyle: "italic",
    },
    welpenGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: "30px",
        maxWidth: "1200px",
        margin: "0 auto",
        "@media (min-width: 768px)": {
            gridTemplateColumns: "repeat(2, 1fr)",
        },
        "@media (min-width: 1024px)": {
            gridTemplateColumns: "repeat(3, 1fr)",
        },
    },
    welpeCard: {
        backgroundColor: "#fff",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
        transition: "all 0.3s ease",
    },
    welpeImageContainer: {
        position: "relative",
        height: "220px",
        overflow: "hidden",
    },
    welpeImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    welpeStatusBadge: {
        position: "absolute",
        top: "15px",
        right: "15px",
        color: "#fff",
        padding: "5px 10px",
        borderRadius: "20px",
        fontSize: "12px",
        fontWeight: "bold",
        boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
    },
    welpeInfo: {
        padding: "20px",
    },
    welpeDetails: {
        marginBottom: "20px",
    },
    welpeDetail: {
        display: "flex",
        marginBottom: "5px",
    },
    welpeDetailLabel: {
        fontWeight: "bold",
        width: "110px",
    },
    welpenNote: {
        maxWidth: "800px",
        margin: "50px auto 0",
        padding: "30px",
        backgroundColor: "#F5F0EB",
        borderRadius: "20px",
        textAlign: "center",
        boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
    },

    // Zuchtvereine Section
    zuchtvereinIntro: {
        maxWidth: "800px",
        margin: "0 auto 40px",
        textAlign: "center",
    },
    zuchtvereinText: {
        fontSize: "1.1rem",
        lineHeight: "1.8",
    },
    zuchtvereinGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: "30px",
        maxWidth: "1200px",
        margin: "0 auto",
        "@media (min-width: 600px)": {
            gridTemplateColumns: "repeat(2, 1fr)",
        },
        "@media (min-width: 1024px)": {
            gridTemplateColumns: "repeat(4, 1fr)",
        },
    },
    zuchtvereinBadge: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
        borderRadius: "15px",
        padding: "30px 20px",
        boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
        transition: "all 0.3s ease",
        textDecoration: "none",
        color: "inherit",
    },
    zuchtvereinLogo: {
        width: "120px",
        height: "80px",
        objectFit: "contain",
        marginBottom: "15px",
    },
    zuchtvereinName: {
        textAlign: "center",
        fontSize: "0.9rem",
        fontWeight: "bold",
    },
    zuchtvereinFooter: {
        maxWidth: "800px",
        margin: "50px auto 0",
        textAlign: "center",
    },
    zuchtvereinFooterText: {
        marginBottom: "30px",
        fontStyle: "italic",
    },

    // Contact Section
    contactContainer: {
        display: "flex",
        flexDirection: "column",
        maxWidth: "1200px",
        margin: "0 auto",
        "@media (min-width: 768px)": {
            flexDirection: "row",
        },
    },
    contactInfo: {
        flex: 1,
        marginBottom: "40px",
        "@media (min-width: 768px)": {
            marginRight: "50px",
            marginBottom: 0,
        },
    },
    contactDetail: {
        display: "flex",
        alignItems: "center",
        marginBottom: "15px",
        "& svg": {
            marginRight: "10px",
        },
    },
    contactText: {
        marginTop: "20px",
        lineHeight: "1.8",
    },
    socialmediaContainer: {
        display: "flex",
        marginTop: "25px",
    },
    socialIcon: {
        width: "40px",
        height: "40px",
        backgroundColor: "#f5f5f5",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "15px",
        color: "#555",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: "#8D6E63",
            color: "#fff",
        },
    },
    contactForm: {
        flex: 1,
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "20px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
    },
    formGroup: {
        marginBottom: "20px",
    },
    label: {
        display: "block",
        marginBottom: "8px",
        fontWeight: "bold",
        color: "#555",
    },
    input: {
        width: "100%",
        padding: "12px 15px",
        borderRadius: "10px",
        border: "2px solid #eee",
        fontSize: "16px",
        fontFamily: "'Montserrat', sans-serif",
        transition: "all 0.3s ease",
        "&:focus": {
            outline: "none",
            borderColor: "#8D6E63",
        },
    },
    textarea: {
        width: "100%",
        padding: "12px 15px",
        borderRadius: "10px",
        border: "2px solid #eee",
        fontSize: "16px",
        fontFamily: "'Montserrat', sans-serif",
        minHeight: "150px",
        resize: "vertical",
        transition: "all 0.3s ease",
        "&:focus": {
            outline: "none",
            borderColor: "#8D6E63",
        },
    },
    button: {
        padding: "12px 25px",
        border: "none",
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        fontWeight: "bold",
        cursor: "pointer",
        transition: "all 0.3s ease",
        boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
        fontFamily: "'Montserrat', sans-serif",
    },
    formSuccess: {
        textAlign: "center",
        padding: "40px 20px",
    },
    successIcon: {
        marginBottom: "20px",
    },

    // Footer
    footer: {
        color: "#fff",
        padding: "70px 20px 30px",
        position: "relative",
        overflow: "hidden",
    },
    footerContent: {
        display: "flex",
        flexDirection: "column",
        maxWidth: "1200px",
        margin: "0 auto",
        marginBottom: "40px",
        position: "relative",
        zIndex: 2,
        "@media (min-width: 768px)": {
            flexDirection: "row",
        },
    },
    footerLogo: {
        flex: 1,
        marginBottom: "30px",
        "@media (min-width: 768px)": {
            marginBottom: 0,
        },
    },
    footerLinks: {
        flex: 1,
        marginBottom: "30px",
        "@media (min-width: 768px)": {
            marginBottom: 0,
        },
        "& ul": {
            listStyle: "none",
            padding: 0,
            margin: 0,
        },
    },
    footerLink: {
        marginBottom: "10px",
        cursor: "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
            opacity: 0.8,
            paddingLeft: "5px",
        },
    },
    footerContact: {
        flex: 1,
    },
    pawPrints: {
        position: "absolute",
        top: "10px",
        left: "0",
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        zIndex: 1,
    },
    footerBottom: {
        borderTop: "1px solid rgba(255,255,255,0.2)",
        paddingTop: "20px",
        textAlign: "center",
        position: "relative",
        zIndex: 2,
    },

    // Dogs Section
    dogsIntro: {
        fontSize: "1.08rem",
    },

    dogsFilterRow: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: 10,
        margin: "22px 0 26px",
    },

    dogsFilterButton: {
        border: "2px solid #E9E2DC",
        padding: "10px 14px",
        borderRadius: "999px",
        fontWeight: "bold",
        cursor: "pointer",
        transition: "all 0.25s ease",
        fontFamily: "'Montserrat', sans-serif",
    },

    dogsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: 18,
        alignItems: "stretch",
    },

    dogsEmptyState: {
        marginTop: 22,
        textAlign: "center",
        backgroundColor: "#F5F0EB",
        borderRadius: 16,
        padding: "18px 16px",
    },

    dogCard: {
        backgroundColor: "#fff",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
        transition: "all 0.3s ease",
        cursor: "default",
    },

    dogImageContainer: {
        position: "relative",
        height: "260px",
        overflow: "hidden",
    },

    dogImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },

    dogSexBadge: {
        position: "absolute",
        top: 14,
        left: 14,
        color: "#fff",
        padding: "6px 12px",
        borderRadius: "999px",
        fontWeight: "bold",
        fontSize: 12,
        boxShadow: "0 3px 6px rgba(0,0,0,0.12)",
    },

    dogBadgesRow: {
        position: "absolute",
        bottom: 12,
        left: 12,
        right: 12,
        display: "flex",
        gap: 8,
        flexWrap: "wrap",
    },

    dogChip: {
        backgroundColor: "rgba(255,255,255,0.92)",
        border: "1px solid rgba(0,0,0,0.06)",
        padding: "5px 10px",
        borderRadius: "999px",
        fontSize: 12,
        fontWeight: "bold",
        color: "#5D4037",
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
    },

    dogInfo: {
        padding: "18px 18px 20px",
    },

    dogHeaderRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
        gap: 10,
    },

    dogName: {
        margin: 0,
        fontSize: "1.25rem",
        fontFamily: "'Playfair Display', serif",
    },

    dogSubtitle: {
        marginTop: 6,
        color: "#8E8E8E",
        fontWeight: "bold",
        fontSize: 13,
    },

    dogDescription: {
        marginTop: 10,
        marginBottom: 10,
        lineHeight: 1.7,
    },

    dogDetails: {
        borderTop: "1px solid #EEE",
        paddingTop: 12,
        marginTop: 10,
    },

    dogDetailRow: {
        display: "flex",
        gap: 8,
        marginBottom: 6,
    },

    dogDetailLabel: {
        fontWeight: "bold",
        width: 92,
        color: "#5D4037",
    },

    dogDetailValue: {
        color: "#4A4A4A",
    },

    dogHighlights: {
        margin: "12px 0 0 18px",
        padding: 0,
        lineHeight: 1.7,
    },

    dogMoreLink: {
        fontWeight: "bold",
        cursor: "pointer",
    },

};
